import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux'
import type { DocRootState, AppDispatch } from './docStore'

export const useAppDispatch: () => AppDispatch = useDispatch
export const useAppSelector: TypedUseSelectorHook<DocRootState> = useSelector